import { useEffect, useState } from 'react';
import { getThumbUrl } from '@/lib/image';

interface ThumbImageProps {
  /** 原图地址（数据库里存的那个） */
  src?: string | null;
  alt: string;
  className?: string;
  /** 原图也加载不出来时的兜底图 */
  fallbackSrc?: string;
  title?: string;
}

/**
 * 列表 / 卡片专用图片：
 * 优先加载后端自动生成的缩略图（体积小、列表更快），
 * 缩略图不存在（老图片）时自动回退到原图，
 * 原图也失败时回退到兜底图，最后才显示占位块——绝不会出现破图图标。
 */
export default function ThumbImage({
  src,
  alt,
  className = '',
  fallbackSrc,
  title,
}: ThumbImageProps) {
  const original = src || fallbackSrc || '';
  const [current, setCurrent] = useState<string>(() => (src ? getThumbUrl(src) : original));
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
    setCurrent(src ? getThumbUrl(src) : original);
  }, [src, original]);

  if (!current || broken) {
    return (
      <div
        className={`${className} flex items-center justify-center bg-[#f8f5f0] text-[#d9cfbe]`}
        aria-label={alt}
      >
        <i className="ri-image-line text-3xl"></i>
      </div>
    );
  }

  const handleError = () => {
    if (original && current !== original) {
      setCurrent(original);
      return;
    }
    if (fallbackSrc && current !== fallbackSrc) {
      setCurrent(fallbackSrc);
      return;
    }
    setBroken(true);
  };

  return (
    <img
      src={current}
      alt={alt}
      title={title}
      className={className}
      onError={handleError}
    />
  );
}